import { Box } from "@mui/material";

const SkeletonSlot = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#f0f0f0',
        borderRadius: '4px',
        p: '4px 6px',
        mb: 0.5,
        position: 'relative',
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '100%',
          height: '100%',
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
          animation: 'shimmer 1.5s infinite',
        },
        '@keyframes shimmer': {
          '0%': { left: '-100%' },
          '100%': { left: '100%' },
        }
      }}
    >
      {/* Time skeleton */}
      <Box
        sx={{
          width: '60%',
          height: '14px',
          backgroundColor: '#e0e0e0',
          borderRadius: '2px',
          mb: 0.5
        }}
      />
      {/* Info skeleton */}
      <Box
        sx={{
          width: '80%',
          height: '11px',
          backgroundColor: '#e0e0e0',
          borderRadius: '2px'
        }}
      />
    </Box>
  );
};

export default SkeletonSlot;
